import React, {Component} from 'react';
import {LayoutSidebar} from "../../../Layout";
import {BusinessUnitTabs} from "../BusinessUnitTabs";
import {BusinessUnitHeader} from "../BusinessUnitHeader";
import {SaveBar} from "../../elements/SaveBar";
import {Account} from "./Account";
import {APIClient} from "../../../utils/APIClient";
import {isOk} from "../../../utils/apiResponse";
import {isPlanLimitError, publishAdAccountQuota, quotaFromLinkError} from "../../../utils/adAccountQuota";
import {planLimitText, recordQuotaEvent} from "../../client/control_central/accountQuota";
import {LoadErrorState} from "../../elements/LoadErrorState";
import {API_URL} from "../../../settings/local_settings";
import {AddAccountModal} from "./add/AddAccountModal";
import {toast} from 'react-toastify';
import {Spinner} from "../../Spinner";
import {METHOD_INCLUDE_ALL_CAMPAIGNS, METHODS_DATA} from "./AccountCampaignsConfiguration";
import {TYPE_ONE_BUDGET_PER_CAMPAIGN, TYPE_ONE_BUDGET_PER_ADGROUP} from "../BusinessUnitTypes";
import {METHOD_ANALYTICS_INCLUDE_ALL_SOURCES_MEDIUMS} from "./Account";
import {withRouterParams} from "../../../utils/withRouterParams";
import {withTranslation} from 'react-i18next';

/** Un solo cartel de GA4 por pantalla, aunque el fetch se dispare dos veces (StrictMode). */
const GA4_ERROR_TOAST_ID = 'bu-accounts-ga4-error';

class BusinessUnitAccounts extends Component {
    constructor(props) {
        super(props);

        this.handleWeekdayAlertChange = this.handleWeekdayAlertChange.bind(this);
        this.executeTimerTillEntitiesAreUpdatedOfAllConfigs = this.executeTimerTillEntitiesAreUpdatedOfAllConfigs.bind(this);
        this.handleWorksOnWeekdayChange = this.handleWorksOnWeekdayChange.bind(this);
        this.handleActionsChange = this.handleActionsChange.bind(this);
        this.handleBudgetChange = this.handleBudgetChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleGA4AccountChange = this.handleGA4AccountChange.bind(this);
        this.handleGA4SourceChange = this.handleGA4SourceChange.bind(this);
        this.handleGA4MediumChange = this.handleGA4MediumChange.bind(this);
        this.handleGA4FiltersChange = this.handleGA4FiltersChange.bind(this);
        this.handleAnalyticsFiltersChange = this.handleAnalyticsFiltersChange.bind(this);
        this.handleGA4OverwriteConversionsChange = this.handleGA4OverwriteConversionsChange.bind(this);
        this.handleReplacesGlobalConversionsChange = this.handleReplacesGlobalConversionsChange.bind(this);
        this.handleGa4AttributionSaved = this.handleGa4AttributionSaved.bind(this);
        this.handleAnalyticsSourceChange = this.handleAnalyticsSourceChange.bind(this);
        this.handleAnalyticsMediumChange = this.handleAnalyticsMediumChange.bind(this);
        this.handleItemsSelectionMethodChange = this.handleItemsSelectionMethodChange.bind(this);
        this.handleItemsSelectionChange = this.handleItemsSelectionChange.bind(this);
        this.handleIncludeTextChange = this.handleIncludeTextChange.bind(this);
        this.handleExcludeTextChange = this.handleExcludeTextChange.bind(this);
        this.handleDeleteAccount = this.handleDeleteAccount.bind(this)
        this.handleRolloverChange = this.handleRolloverChange.bind(this);
        this.handleItemBudgetChange = this.handleItemBudgetChange.bind(this);
        this.handleAddAccount = this.handleAddAccount.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleGoToTabUrl = this.handleGoToTabUrl.bind(this);
        this.loadScreenData = this.loadScreenData.bind(this);
        this.handleRetryLoad = this.handleRetryLoad.bind(this);
        this.handleRefreshItemsList = this.handleRefreshItemsList.bind(this);
        this.handleLoadInactiveCampaigns = this.handleLoadInactiveCampaigns.bind(this);
        this.handleLoadInactiveAdgroups = this.handleLoadInactiveAdgroups.bind(this);

        this.state = {
            saving: false,
            hasChanges: false,
            campaignConfigurations: null,
            allAgencyGA4Accounts: null,
            canEditCurrency: null,
            // Falló alguno de los DOS fetches que gatean la pantalla (configuraciones de cuenta o
            // presupuesto). Estado propio y UNO SOLO: los dos alimentan la misma lista y el
            // reintentar es el mismo gesto. `null` = sin error; string (puede ser '') = con error.
            // Sin esto, un `return` a secas deja `renderAccounts()` en el `.box-loader` PARA
            // SIEMPRE: gatea por `canEditCurrency !== null` y ese dato sale del fetch que falló.
            loadError: null,
            // Cambia en cada reintento y viaja como `key` del encabezado. `BusinessUnitHeader` pide
            // su dato UNA sola vez, en el montaje y sólo si no lo tiene, así que sin esto un
            // reintento exitoso dejaba el encabezado vacío hasta que el usuario recargara la página
            // entera (QA-net-01b). Cambiar la `key` lo remonta, que es lo que lo hace volver a pedir.
            headerRetryToken: 0,
            ga4IsEnabled: null,
            ga4IsConnected: null,
            configIdsRefreshingAccountEntities: [],
            isLoadingInactiveItems: false,
        }

        this.syncInterval = null;
    }

    handleGoToTabUrl(url) {
        this.props.history.push(url);
    }

    componentDidMount() {
        this.loadScreenData();
    }

    /**
     * Los tres fetches de montaje. Juntos porque alimentan UNA sola cosa -la lista de cuentas- y
     * porque los tres son GET idempotentes: reintentar uno que ya había andado no cuesta nada.
     */
    loadScreenData() {
        this.getAllAgencyGA4Accounts();
        this.getAllAccountsInformation();
        this.getBudget();
    }

    /**
     * Vuelve al loader. `renderAccounts()` gatea por `campaignConfigurations` y `canEditCurrency`
     * en `null`, así que resetearlos es lo que hace que el click SE VEA; sin eso la pantalla de
     * error se queda igual hasta que responda el request y el usuario vuelve a clickear.
     */
    handleRetryLoad() {
        // El polling de entidades se apaga ANTES de vaciar el mapa. `campaignConfigurations: null`
        // es lo que hace visible el reintento, pero `checkSyncStatus` indexa ese mapa cada 10s: si
        // el interval sigue vivo, el tick siguiente revienta -- y si el reintento tambien falla, lo
        // hace cada 10s indefinidamente, cada vez a Sentry. La recarga exitosa repuebla los ids y
        // vuelve a arrancar el interval por su cuenta (`executeTimerTillEntitiesAreUpdatedOfAllConfigs`).
        if (this.syncInterval) {
            clearInterval(this.syncInterval);
            this.syncInterval = null;
        }
        this.setState((prev) => ({
            loadError: null,
            campaignConfigurations: null,
            canEditCurrency: null,
            allAgencyGA4Accounts: null,
            configIdsRefreshingAccountEntities: [],
            headerRetryToken: prev.headerRetryToken + 1,
        }), this.loadScreenData);
    }

    /**
     * Un solo camino para marcar que la pantalla no pudo cargar.
     *
     * Retira de paso el aviso de GA4: si ese fetch respondió ANTES que el que falló, su cartel ya
     * está en pantalla afirmando que «el resto funciona igual», justo cuando no funciona nada.
     */
    setLoadError(response) {
        toast.dismiss(GA4_ERROR_TOAST_ID);
        this.setState({loadError: response.error_message || ''});
    }

    // API calls

    getAllAgencyGA4Accounts() {
        new APIClient(this.allAgencyGA4AccountsURL()).call('GET').then((response) => {
            if (isOk(response)) {
                this.setState({
                    allAgencyGA4Accounts: response.data
                })
                return;
            }
            // Fetch SECUNDARIO: no gatea la pantalla (`Account._getFormattedAllGA4Accounts` ya
            // trata `null` como lista vacía), así que tumbar las cuentas por esto sería
            // desproporcionado. Se queda en `null` y NO en `[]`: `[]` afirmaría "esta agencia no
            // tiene ninguna propiedad de GA4", que no es lo que pasó.
            //
            // El aviso dice que «el resto de la configuración funciona igual», así que NO sale si la
            // pantalla entera ya falló: ahí nada funciona y el cartel contradice al bloque de error
            // que tiene al lado (QA-VIS-net-10). La carrera inversa -que GA4 responda primero y los
            // otros fallen después- la cubre el `toast.dismiss` de `setLoadError`.
            if (this.state.loadError !== null) {
                return;
            }
            // El `toastId` garantiza UNO solo aunque el fetch se dispare dos veces: en desarrollo
            // `React.StrictMode` monta dos veces y se apilaban dos carteles idénticos, que a 390
            // tapaban el encabezado entero (QA-VIS-net-09).
            const {t} = this.props;
            toast.error(t('business_unit_accounts.ga4_accounts_error'), {toastId: GA4_ERROR_TOAST_ID});
        });
    }

    _getAdAccountIdFromConfig(configId) {
        if (this.state.campaignConfigurations === null)
            return null;

        return this.state.campaignConfigurations[configId]["ad_account_id"];
    }

    updateConfigData(configId, data) {
        const updatedCampaignConfiguration = this.state.campaignConfigurations[configId];
        // Esta info puede venir de 2 endpoints distintos por eso las keys distintas para lo mismo
        updatedCampaignConfiguration["all_account_campaigns"] = data["campaigns"] !== undefined ? data["campaigns"] : data["all_account_campaigns"]
        updatedCampaignConfiguration["all_account_adgroups"] = data["adgroups"] !== undefined ? data["adgroups"] : data["all_account_adgroups"]
        updatedCampaignConfiguration["all_actions"] = data["actions"] !== undefined ? data["actions"] : data["all_actions"];
        updatedCampaignConfiguration["last_entities_update_on_formatted"] = data["last_entities_update_on_formatted"];
        updatedCampaignConfiguration["last_entities_update_on"] = data["last_entities_update_on"];

        // Inicializar analytics_configuration si es necesario
        this.initializeAnalyticsConfigurationForConfig(updatedCampaignConfiguration);

        const campaignConfigurations = this.state.campaignConfigurations;
        campaignConfigurations[configId] = updatedCampaignConfiguration;

        const configIdsUpdatingEntities = this.state.configIdsRefreshingAccountEntities.filter(item => item !== configId);
        this.setState({
            campaignConfigurations: campaignConfigurations,
            configIdsRefreshingAccountEntities: configIdsUpdatingEntities
        });
    }

    updateInactiveItemsConfigData(configId, data) {
        const updatedCampaignConfiguration = this.state.campaignConfigurations[configId];
        updatedCampaignConfiguration["all_not_active_campaigns"] = data["all_not_active_campaigns"] !== undefined ? data["all_not_active_campaigns"] : updatedCampaignConfiguration["all_not_active_campaigns"];
        updatedCampaignConfiguration["all_not_active_adgroups"] = data["all_not_active_adgroups"] !== undefined ? data["all_not_active_adgroups"] : updatedCampaignConfiguration["all_not_active_adgroups"];

        const campaignConfigurations = this.state.campaignConfigurations;
        campaignConfigurations[configId] = updatedCampaignConfiguration;

        this.setState({
            campaignConfigurations: campaignConfigurations,
            isLoadingInactiveItems: false
        });
    }

    initializeAnalyticsConfigurationForConfig(config) {
        // Si ya existe analytics_configuration y es un array válido, mantenerlo
        if (config.analytics_configuration && Array.isArray(config.analytics_configuration) && config.analytics_configuration.length > 0) {
            return config;
        }
        
        // Si no existe, inicializar desde analytics_source y analytics_medium
        const source = config.analytics_source || '';
        const medium = config.analytics_medium || '';
        if (source || medium) {
            config.analytics_configuration = [{source: source, medium: medium}];
        } else {
            config.analytics_configuration = [];
        }
        
        return config;
    }

    getAllAccountsInformation() {
        const url = this.businessUnitAccountsURL();
        new APIClient(url).call('GET').then((response) => {
            if (response.status === 'OK') {
                let accountsWithErrors = [];
                const syncingForFirstTimeConfigIds = [];
                
                // Inicializar analytics_configuration para cada configuración
                const processedData = {};
                Object.keys(response.data).forEach((campaignConfigurationId) => {
                    const config = response.data[campaignConfigurationId];
                    processedData[campaignConfigurationId] = this.initializeAnalyticsConfigurationForConfig({...config});

                    if (config.last_entities_update_on !== null) {
                        if (config.all_account_campaigns === null || config.all_account_adgroups === null) {
                            accountsWithErrors.push(config.name)
                        }
                    } else {
                        syncingForFirstTimeConfigIds.push(campaignConfigurationId);
                    }
                });

                if (accountsWithErrors.length > 0) {
                    const errorMessage = accountsWithErrors.join(', ');
                    alert(`Hubo un error al cargar las campañas de las cuentas ${errorMessage}`)
                }

                this.setState({
                    campaignConfigurations: processedData,
                    configIdsRefreshingAccountEntities: syncingForFirstTimeConfigIds
                }, this.executeTimerTillEntitiesAreUpdatedOfAllConfigs);
            } else {
                // Con `status === 'OK'` a secas, un NETWORK_ERROR caía en este `else` y abría un
                // alert() -- modal nativo que congela el hilo-- dejando la pantalla en el loader
                // para siempre. `error_message` puede venir vacío: el render tiene su propio texto
                // y esto queda como detalle, que no se muestra.
                this.setLoadError(response);
            }
        });
    }

    executeTimerTillEntitiesAreUpdatedOfAllConfigs() {
        // Disparo los gets al server para actualizar entidades hasta que SyncEntities se actualise
        // Si es mayor a cero significa que ya está chequeando
        if (this.state.configIdsRefreshingAccountEntities.length > 0 && this.syncInterval === null) {
            this.syncInterval = setInterval(this.checkSyncStatus.bind(this), 10000);
        }
    }

    componentWillUnmount() {
        // Clear the interval if the component is unmounting.
        if (this.syncInterval) {
            clearInterval(this.syncInterval);
        }
    }

    checkSyncStatus() {
        // El mapa puede estar en `null` y no solo incompleto: el reintento de la pantalla lo vacia
        // mientras recarga. `if (!config)` de mas abajo cubre una key faltante, no un mapa nulo.
        if (this.state.campaignConfigurations === null) {
            return;
        }

        // Que deje de consultar el estado si ya esta to.do actualizado
        if(this.state.configIdsRefreshingAccountEntities.length === 0) {
            clearInterval(this.syncInterval);
            this.syncInterval = null;
            return;
        }

        this.state.configIdsRefreshingAccountEntities.forEach(configId => {
            const config = this.state.campaignConfigurations[configId];
            if (!config) return;
            const lastUpdatedOn = config.last_entities_update_on;
            new APIClient(API_URL + 'campaigns-configurations/'+configId+'/get-on-synced').call('POST', {"data_only_if_updated_after":lastUpdatedOn}).then((data) => {
                // Refresco de FONDO: lo dispara un timer cada 10s, no un gesto del usuario. Un
                // fallo no dice nada y la fila conserva el dato que ya tenia -- interrumpir a
                // alguien que no pidio nada es peor, y con un cartel cada 10s es insoportable. El
                // tick siguiente reintenta solo, y los 5xx ya viajan a Sentry desde `APIClient`.
                // Antes esto era `=== 'ERROR'` + alert(): el literal no matchea un NETWORK_ERROR ni
                // un codigo tipado, asi que el cartel salia justo cuando NO correspondia.
                if (isOk(data)) {
                    // Si se trata de una cuenta que nunca se sincronizó y ahora si o si la sincronizar es mas nueva
                    const currentConfig = this.state.campaignConfigurations[configId];
                    if (!currentConfig) return;
                    const old_last_entities_update_on = currentConfig.last_entities_update_on
                    const new_last_entities_update_on = data.data["last_entities_update_on"]
                    if((old_last_entities_update_on === null && new_last_entities_update_on !== null) || old_last_entities_update_on < new_last_entities_update_on) {
                        this.updateConfigData(configId, data.data);
                    }
                }
            })
        });
    }

    refreshEntitiesOfAdAccountAsync(configId) {
        const configIdsUpdatingEntities = this.state.configIdsRefreshingAccountEntities;
        configIdsUpdatingEntities.push(configId)
        this.setState({
            ...this.state,
            configIdsRefreshingAccountEntities: configIdsUpdatingEntities
        });

        const adAccountId = this._getAdAccountIdFromConfig(configId);
        const url = this.businessUnitAccountUpdateEntitiesURL(adAccountId);
        new APIClient(url).call('GET').then((response) => {
            if (response.status !== 'OK') {
                alert(response.error_message);
            }
        });

        this.executeTimerTillEntitiesAreUpdatedOfAllConfigs();
    }

    loadInactiveCampaigns(configId) {
        this.setState({
            ...this.state,
            isLoadingInactiveItems: true
        }, () => {
            const adAccountId = this._getAdAccountIdFromConfig(configId);
            const url = this.businessUnitAccountGetInactiveCampaignsURL(adAccountId);
            new APIClient(url).call('GET').then((response) => {
                if (response.status !== 'OK') {
                    alert(response.error_message);
                } else {
                    this.updateInactiveItemsConfigData(configId, response.data);
                }
            });
        });
    }

    loadInactiveAdgroups(configId) {
        this.setState({
            ...this.state,
            isLoadingInactiveItems: true
        }, () => {
            const adAccountId = this._getAdAccountIdFromConfig(configId);
            const url = this.businessUnitAccountGetInactiveAdgroupsURL(adAccountId);
            new APIClient(url).call('GET').then((response) => {
                if (response.status !== 'OK') {
                    alert(response.error_message);
                } else {
                    this.updateInactiveItemsConfigData(configId, response.data);
                }
            });
        });
    }

    getAccountCampaignsAndAdgroups(adAccountId, configId) {
        this.setState({campaigns: null, adgroups: null});
        const businessUnitCampaignsDataURL = this.getCampaignsConfigurationDataURL(adAccountId, configId);

        new APIClient(businessUnitCampaignsDataURL).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                const editedAccounts = this.editedAccounts({all_account_campaigns: data.all_selectable_campaigns, all_account_adgroups: data.all_selectable_adgroups}, configId);
                this.setState({
                    ...this.state,
                    campaignConfigurations: editedAccounts
                });
            }
        })
    }

    editCampaignsConfigurations(data) {
        const apiClient = new APIClient(this.editCampaignsConfigurationURL());
        return apiClient.call('PUT', data);
    }

    getBudget() {
        const apiClient = new APIClient(this.budgetURL());
        apiClient.call('GET').then((response) => this.getBudgetCallback(response));
    }

    // rendering

    render() {
        const businessUnitId = this.businessUnitId();
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content">
                    <BusinessUnitHeader key={this.state.headerRetryToken} businessUnitId={businessUnitId}/>
                    <BusinessUnitTabs businessUnitId={businessUnitId}
                                      activeTab="-second"
                                      changesMade={this.state.hasChanges}
                                      goToTabUrl={this.handleGoToTabUrl}
                    />
                    <div>
                        <div className="section-body">
                            {this.state.loadError !== null ? this.renderLoadError() : (
                                <React.Fragment>
                                    {this.renderAddAccountModal()}
                                    {this.renderAccounts()}
                                </React.Fragment>
                            )}
                        </div>
                        {/* La barra de guardado sale con el error: es fija al pie y afirma «Todos
                            los cambios fueron guardados» con un check verde, que sobre una pantalla
                            que no pudo cargar nada es falso -- la misma clase de mentira que este
                            frente vino a matar. */}
                        {this.state.loadError === null &&
                            <SaveBar onClick={this.handleSubmit} isSaving={this.state.saving}
                                     hasChanges={this.state.hasChanges}/>}
                    </div>
                </section>
            </div>
        )
    }

    handleRefreshItemsList(configId) {
        this.refreshEntitiesOfAdAccountAsync(configId);
    }

    handleLoadInactiveCampaigns(configId) {
        this.loadInactiveCampaigns(configId);
    }

    handleLoadInactiveAdgroups(configId) {
        this.loadInactiveAdgroups(configId);
    }

    /**
     * Va DENTRO de `.section-body`, no en lugar de la pantalla entera: así el encabezado de la
     * Línea y sus pestañas siguen ahí y el usuario puede irse a otro lado sin el botón del
     * navegador.
     */
    renderLoadError() {
        const {t} = this.props;
        return <LoadErrorState title={t('business_unit_accounts.load_error')}
                               text={t('business_unit_accounts.load_error_explanation')}
                               retryLabel={t('business_unit_accounts.load_error_retry')}
                               onRetry={this.handleRetryLoad}/>;
    }

    renderAccounts() {
        if (this.state.campaignConfigurations !== null && this.state.canEditCurrency !== null) {
            const onlyOne = Object.keys(this.state.campaignConfigurations).length === 1;
            return Object.keys(this.state.campaignConfigurations).map((configId) => {
                const campaignsConfiguration = this.state.campaignConfigurations[configId];
                const userCampaignsConfigurationSettings = campaignsConfiguration["user_campaigns_configuration_settings"];
                return (
                    <Account
                        isOpen={onlyOne}
                        key={configId}
                        configId={configId}
                        onItemBudgetChange={this.handleItemBudgetChange}
                        budgetType={this.props.budgetType}
                        businessUnitType={this.state.businessUnitType}
                        canEditCurrency={this.state.canEditCurrency}
                        allGA4Accounts={this.state.allAgencyGA4Accounts}
                        campaignsConfigurationData={campaignsConfiguration}
                        userCampaignsConfigurationSettingsData={userCampaignsConfigurationSettings}
                        onWeekdayAlertChange={this.handleWeekdayAlertChange}
                        onWorksOnWeekdayChange={this.handleWorksOnWeekdayChange}
                        onRolloverChange={this.handleRolloverChange}
                        onActionsChange={this.handleActionsChange}
                        onBudgetChange={this.handleBudgetChange}
                        onAccountChange={this.handleAccountChange}
                        onGA4AccountChange={this.handleGA4AccountChange}
                        onGA4SourceChange={this.handleGA4SourceChange}
                        onGA4MediumChange={this.handleGA4MediumChange}
                        onGA4FiltersChange={this.handleGA4FiltersChange}
                        onAnalyticsFiltersChange={this.handleAnalyticsFiltersChange}
                        onGA4OverwriteConversionsChange={this.handleGA4OverwriteConversionsChange}
                        onReplacesGlobalConversionsChange={this.handleReplacesGlobalConversionsChange}
                        onGa4AttributionSaved={this.handleGa4AttributionSaved}
                        onAnalyticsSourceChange={this.handleAnalyticsSourceChange}
                        onAnalyticsMediumChange={this.handleAnalyticsMediumChange}
                        onItemsSelectionMethodChange={this.handleItemsSelectionMethodChange}
                        onItemsSelectionChange={this.handleItemsSelectionChange}
                        onIncludeTextChange={this.handleIncludeTextChange}
                        onExcludeTextChange={this.handleExcludeTextChange}
                        onDeleteAccount={this.handleDeleteAccount}
                        ga4IsEnabled={this.state.ga4IsEnabled}
                        ga4IsConnected={this.state.ga4IsConnected}
                        selectionMethodsAllowed={this.state.selectionMethodsAllowed}
                        onRefreshItemsList={this.handleRefreshItemsList}
                        isUpdatingListItems={this.state.configIdsRefreshingAccountEntities.includes(configId)}
                        messageForRefreshListItemsIconToolbox={`Última sincronización: ${campaignsConfiguration["last_entities_update_on_formatted"]}`}
                        onLoadInactiveCampaigns={this.handleLoadInactiveCampaigns}
                        onLoadInactiveAdgroups={this.handleLoadInactiveAdgroups}
                        isLoadingInactiveItems={this.state.isLoadingInactiveItems}
                    />
                );
            });
        } else {
            return (<div className="box-loader">
                <Spinner color="positive"/>
            </div>)
        }
    }

    renderAddAccountModal() {
        // Check if the URL contains the parameter that indicates modal display
        const params = new URLSearchParams(this.props.location.search);
        const shouldShowModal = params.get('showAddAccountModal') !== null && params.get('showAddAccountModal') === "true";

        return (
            <AddAccountModal
                showModalWhenCreated={shouldShowModal}
                businessUnitId={this.businessUnitId()}
                allocatedBudget={this.state.allocatedBudget}
                afterSuccessfulSubmit={this.handleAddAccount}
            />
        )
    }

    // handlers
    handleWorksOnWeekdayChange(name, value, configId) {
        let new_values = {};
        new_values[`${name}`] = value;
        const editedAccounts = this.editedAccounts(new_values, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleWeekdayAlertChange(name, value, configId) {
        let new_values = {};
        new_values[`${name}`] = value;
        const editedAccounts = this.editedUserAccounts(new_values, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleRolloverChange(value, configId) {
        const editedAccounts = this.editedAccounts({rollover: value}, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleItemBudgetChange(configId, allocatedBudgetByItemId, selectedCampaigns, selectedAdgroups) {
        let totalBudget = this.getTotalAllocatedAmountInItemsIfCorresponds(allocatedBudgetByItemId);

        const budgetByCampaignId = this.isSelectingCampaigns(configId) ? allocatedBudgetByItemId : {};
        const budgetByAdgroupId = this.isSelectingAdgroups(configId) ? allocatedBudgetByItemId : {};

        const editedAccounts = this.editedAccounts({
            budget_by_campaign_id: budgetByCampaignId,
            budget_by_adgroup_id: budgetByAdgroupId,
            allocated_budget: totalBudget,
            selected_campaigns: selectedCampaigns !== null ? selectedCampaigns: this.state.campaignConfigurations[configId].selected_campaigns,
            selected_adgroups: selectedAdgroups !== null ? selectedAdgroups: this.state.campaignConfigurations[configId].selected_adgroups
        }, configId);

        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    getTotalAllocatedAmountInItemsIfCorresponds(allocatedBudgetByItemId) {
        if(this.state.businessUnitType !== TYPE_ONE_BUDGET_PER_CAMPAIGN && this.state.businessUnitType !== TYPE_ONE_BUDGET_PER_ADGROUP)
            return this.state.allocatedBudget;

        let totalBudget = 0;
        for (let itemId in allocatedBudgetByItemId) {
            if (allocatedBudgetByItemId.hasOwnProperty(itemId)) {
                totalBudget += allocatedBudgetByItemId[itemId];
            }
        }
        return totalBudget;
    }

    handleBudgetChange(currency, amount, configId) {
        const editedAccounts = this.editedAccounts({currency: currency, allocated_budget: amount}, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    getResetAllocatedBudgetIfNeedsTo() {
        if(this.state.businessUnitType ===  TYPE_ONE_BUDGET_PER_CAMPAIGN || this.state.businessUnitType ===  TYPE_ONE_BUDGET_PER_ADGROUP)
            return 0
        else
            return this.state.allocatedBudget;
    }

    handleAccountChange(newAdAccountId, newAccountName, configId) {
        const editedValues = {
            ad_account_id: newAdAccountId,
            name: newAccountName,
            selection_method: METHOD_INCLUDE_ALL_CAMPAIGNS,
            selected_campaigns: [],
            selected_adgroups: [],
            budget_by_campaign_id: {},
            budget_by_adgroup_id: {},
            allocated_budget: this.getResetAllocatedBudgetIfNeedsTo()
        };
        const editedAccounts = this.editedAccounts(editedValues, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
        this.getAccountCampaignsAndAdgroups(newAdAccountId, configId);
    }

    isSelectingCampaigns(configId) {
        return METHODS_DATA[this.state.campaignConfigurations[configId].selection_method]["selectingCampaigns"];
    }

    isSelectingAdgroups(configId) {
        return METHODS_DATA[this.state.campaignConfigurations[configId].selection_method]["selectingAdgroups"];
    }

    handleGA4AccountChange(newAdAccountId, newAccountName, configId) {
        const editedValues = {
            ga4_ad_account_account_id: newAdAccountId,
            ga4_ad_account_id: null,
        };
        
        // Si se des-asocia la cuenta (newAdAccountId es null), limpiar también Source y Medium
        if (newAdAccountId === null) {
            editedValues.ga4_source = "";
            editedValues.ga4_medium = "";
        }
        
        const editedAccounts = this.editedAccounts(editedValues, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleGA4OverwriteConversionsChange(overwrite, configId) {
        const editedValues = {
            ga4_overwrite_purchase_value_and_convertions: overwrite
        };
        const editedAccounts = this.editedAccounts(editedValues, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleReplacesGlobalConversionsChange(replacesGlobalConversions, configId) {
        const editedValues = {
            replaces_global_conversions: replacesGlobalConversions
        };
        const editedAccounts = this.editedAccounts(editedValues, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    /**
     * La regla de cruce con GA4 de una cuenta se guardó desde el modal de la línea. Es de la CUENTA,
     * no de la línea: no ensucia la línea (`hasChanges` queda como estaba) y se refleja en todas las
     * cuentas de la pantalla que usan esa misma cuenta del cliente.
     */
    handleGa4AttributionSaved(attribution, configId) {
        if (!attribution || this.state.campaignConfigurations === null) return;
        const clientAdAccountId = attribution.client_ad_account_id;
        const campaignConfigurations = {...this.state.campaignConfigurations};
        Object.keys(campaignConfigurations).forEach((id) => {
            const current = campaignConfigurations[id].ga4_attribution;
            const sameAccount = id === configId || (current && clientAdAccountId && current.client_ad_account_id === clientAdAccountId);
            if (sameAccount) campaignConfigurations[id] = {...campaignConfigurations[id], ga4_attribution: {...current, ...attribution}};
        });
        this.setState({campaignConfigurations});
    }

    handleGA4SourceChange(newSource, configId) {
        const editedValues = {
            ga4_source: newSource
        };
        const editedAccounts = this.editedAccounts(editedValues, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleGA4MediumChange(newMedium, configId) {
        const editedValues = {
            ga4_medium: newMedium
        };
        const editedAccounts = this.editedAccounts(editedValues, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleGA4FiltersChange(newFilters, configId) {
        // El BUCC migra a modo live-api: el backend limpia las columnas legacy al recibir ga4_filters.
        const editedAccounts = this.editedAccounts({ga4_filters: newFilters}, configId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleAnalyticsFiltersChange(newFilters, configId) {
        const editedAccounts = this.editedAccounts({ga4_filters: newFilters}, configId);
        this.setState({
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    getOrInitializeAnalyticsConfiguration(configId) {
        const config = this.state.campaignConfigurations[configId];
        if (config.analytics_configuration && Array.isArray(config.analytics_configuration) && config.analytics_configuration.length > 0) {
            return [...config.analytics_configuration];
        }
        // Si no existe o está vacío, inicializar con los valores actuales de analytics_source y analytics_medium
        const source = config.analytics_source || '';
        const medium = config.analytics_medium || '';
        if (source || medium) {
            return [{source: source, medium: medium}];
        }
        return [];
    }

    handleAnalyticsSourceChange(newSource, configId) {
        const analyticsConfiguration = this.getOrInitializeAnalyticsConfiguration(configId);
        // Crear una nueva copia del array para evitar mutaciones
        let updatedConfiguration;
        if (analyticsConfiguration.length > 0) {
            updatedConfiguration = [{
                ...analyticsConfiguration[0],
                source: newSource
            }];
        } else {
            updatedConfiguration = [{source: newSource, medium: ''}];
        }

        const editedValues = {
            analytics_configuration: updatedConfiguration,
            analytics_source: newSource // Mantener compatibilidad hacia atrás
        };
        const editedAccounts = this.editedAccounts(editedValues, configId);
        this.setState({
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleAnalyticsMediumChange(newMedium, configId) {
        const analyticsConfiguration = this.getOrInitializeAnalyticsConfiguration(configId);
        // Crear una nueva copia del array para evitar mutaciones
        let updatedConfiguration;
        if (analyticsConfiguration.length > 0) {
            updatedConfiguration = [{
                ...analyticsConfiguration[0],
                medium: newMedium
            }];
        } else {
            updatedConfiguration = [{source: '', medium: newMedium}];
        }

        const editedValues = {
            analytics_configuration: updatedConfiguration,
            analytics_medium: newMedium // Mantener compatibilidad hacia atrás
        };
        const editedAccounts = this.editedAccounts(editedValues, configId);
        this.setState({
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleDeleteAccount(campaignsConfigurationId) {
        const deleteCampaignConfigurationURL = this.getDeleteCampaignConfigurationURL(campaignsConfigurationId)
        new APIClient(deleteCampaignConfigurationURL).call('DELETE').then((data) => {
            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                const editedAccounts = this.removeAccount(campaignsConfigurationId);
                this.setState({
                    ...this.state,
                    campaignConfigurations: editedAccounts
                });
            }
        })
    }

    handleItemsSelectionMethodChange(value, accountId) {
        const campaignConfig = this.state.campaignConfigurations[accountId];
        const editedValues = {
            selection_method: value,
            selected_campaigns: [],
            selected_adgroups: [],
            budget_by_campaign_id: {},
            budget_by_adgroup_id: {},
            allocated_budget: this.getResetAllocatedBudgetIfNeedsTo()
        };

        // Si es Analytics y se cambia a incluir todo el tráfico, limpiar source y medium
        if (campaignConfig && campaignConfig.channel === 'ANALYTICS') {
            if (value === METHOD_ANALYTICS_INCLUDE_ALL_SOURCES_MEDIUMS || value === 'ANALYTICS_INCLUDE_ALL_TRAFFIC') {
                editedValues.analytics_source = '';
                editedValues.analytics_medium = '';
                editedValues.analytics_configuration = [];
            }
        }

        const editedAccounts = this.editedAccounts(editedValues, accountId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleItemsSelectionChange(selectedItems, allocatedBudgetByItemId, accountId) {
        let totalBudget = this.getTotalAllocatedAmountInItemsIfCorresponds(allocatedBudgetByItemId);

        const editedValues = {
            selected_campaigns: this.isSelectingCampaigns(accountId) ? selectedItems : [],
            selected_adgroups: this.isSelectingAdgroups(accountId) ? selectedItems : [],
            budget_by_campaign_id: this.isSelectingCampaigns(accountId) ? allocatedBudgetByItemId : {},
            budget_by_adgroup_id: this.isSelectingAdgroups(accountId) ? allocatedBudgetByItemId : {},
            allocated_budget: totalBudget
        };

        const editedAccounts = this.editedAccounts(editedValues, accountId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleIncludeTextChange(newText, allocatedBudgetByItemId, accountId) {
        let totalBudget = this.getTotalAllocatedAmountInItemsIfCorresponds(allocatedBudgetByItemId);

        const editedValues = {
            include_containing: newText,
            budget_by_campaign_id: this.isSelectingCampaigns(accountId) ? allocatedBudgetByItemId : {},
            budget_by_adgroup_id: this.isSelectingAdgroups(accountId) ? allocatedBudgetByItemId : {},
            allocated_budget: totalBudget
        };

        const editedAccounts = this.editedAccounts(editedValues, accountId);

        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleExcludeTextChange(newText, allocatedBudgetByItemId, accountId) {
        let totalBudget = this.getTotalAllocatedAmountInItemsIfCorresponds(allocatedBudgetByItemId);

        const editedValues = {
            exclude_containing: newText,
            budget_by_campaign_id: this.isSelectingCampaigns(accountId) ? allocatedBudgetByItemId : {},
            budget_by_adgroup_id: this.isSelectingAdgroups(accountId) ? allocatedBudgetByItemId : {},
            allocated_budget: totalBudget
        };

        const editedAccounts = this.editedAccounts(editedValues, accountId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleActionsChange(actions, accountId) {
        const editedAccounts = this.editedAccounts({selected_actions: actions}, accountId);
        this.setState({
            ...this.state,
            hasChanges: true,
            campaignConfigurations: editedAccounts
        });
    }

    handleSubmit() {
        this.setState({saving: true});
        this.editCampaignsConfigurations(this.campaignConfigurationsWithChangesToPost()).then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'ERROR_CONDITION_TO_INCLUDE_CAMPAIGNS_INVALID') {
                alert(response.error_message);
            } else if (isPlanLimitError(response)) {
                // El tope del plan, con sus números y el mismo texto que el resto de las pantallas (UD-15);
                // no el `error_message` del backend en un `alert()`.
                recordQuotaEvent('rejected', 'line_accounts');
                const quota = quotaFromLinkError(response);
                toast.error(planLimitText(this.props.t, quota));
                publishAdAccountQuota(quota);
            } else if (response.status === 'ERROR_AT_LEAST_ONE_CAMPAIGN' || response.status === 'ERROR_AT_LEAST_ONE_ADGROUP') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({hasChanges: false});
                this.markAllAccountsAsNotChanges();
                if (response.data.bu_is_being_synced) {
                    toast.info('Las cuentas están siendo sincronizadas!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true
                    });
                }
            }
            this.setState({saving: false});
        });
    }

    handleAddAccount(newAccountDataByConfigId) {
        this.setState({
            ...this.state,
            campaignConfigurations: {
                ...this.state.campaignConfigurations,
                ...newAccountDataByConfigId
            }
        });
    }

    // callbacks

    getBudgetCallback(response) {
        // FRONTEND-47. Preguntaba por `status === 'ERROR'`, que no matchea el `NETWORK_ERROR` que
        // devuelve el `APIClient` ante un microcorte ni los códigos tipados del backend: los dos
        // caían en el `else` -la rama de ÉXITO- y morían en `response.data.allocated_budget`.
        // El endpoint responde con `OKResponse`
        // (`core/views/business_units/shared_budget.py`), así que `status` siempre viaja.
        if (!isOk(response)) {
            this.setLoadError(response);
            return;
        }
        this.setState({
            allocatedBudget: response.data.allocated_budget,
            canEditCurrency: response.data.can_edit_currency,
            ga4IsEnabled: response.data.ga4_is_enabled,
            ga4IsConnected: response.data.ga4_is_connected,
            selectionMethodsAllowed: response.data.selection_methods_allowed,
            budgetType: response.data.budget_type,
            businessUnitType: response.data.business_unit_type
            // Ojo: acá NO se limpia `loadError`. Los tres fetches de montaje corren en paralelo y
            // el error es UNO solo, así que el camino de éxito de uno borraría el error del otro:
            // si fallan las configuraciones de cuenta y el presupuesto responde bien, la pantalla
            // volvía al loader eterno sin decir nada. Lo limpia `handleRetryLoad`, que es el único
            // que sabe que se están pidiendo los tres de nuevo.
        })
    }

// aux

    editedAccounts(editedValues, accountConfigId) {
        let campaignConfigurations = {};
        Object.keys(this.state.campaignConfigurations).forEach((configId) => {
            if (accountConfigId === configId) {
                campaignConfigurations[accountConfigId] = {
                    hasChanges: true,
                    ...this.state.campaignConfigurations[accountConfigId],
                    ...editedValues
                };
            } else {
                campaignConfigurations[configId] = this.state.campaignConfigurations[configId]
            }
        });
        return campaignConfigurations;
    }

    removeAccount(accountConfigId) {
        let campaignConfigurations = {};
        Object.keys(this.state.campaignConfigurations).forEach((configId) => {
            if (accountConfigId !== configId) {
                campaignConfigurations[configId] = this.state.campaignConfigurations[configId]
            }
        });
        return campaignConfigurations;
    }

    editedUserAccounts(editedValues, accountConfigId) {
        let campaignConfigurations = {};
        Object.keys(this.state.campaignConfigurations).forEach((configId) => {
            if (accountConfigId === configId) {
                campaignConfigurations[accountConfigId] = {
                    hasChanges: true,
                    ...this.state.campaignConfigurations[accountConfigId],
                    user_campaigns_configuration_settings: {
                        ...this.state.campaignConfigurations[accountConfigId].user_campaigns_configuration_settings,
                        ...editedValues
                    }
                };
            } else {
                campaignConfigurations[configId] = this.state.campaignConfigurations[configId]
            }
        });
        return campaignConfigurations;
    }

    markAllAccountsAsNotChanges() {
        let campaignConfigurations = {};
        Object.keys(this.state.campaignConfigurations).forEach((configId) => {
            campaignConfigurations[configId] = {
                hasChanges: false,
                ...this.state.campaignConfigurations[configId],
            };
        });
        this.setState({
            campaignConfigurations: campaignConfigurations
        });
    }

    campaignConfigurationsWithChangesToPost() {
        let campaignConfigurations = {};
        Object.keys(this.state.campaignConfigurations).forEach((configId) => {
            const config = this.state.campaignConfigurations[configId];
            if (config.hasChanges) {
                const campaignConfigurationsDataToPost = {...this.state.campaignConfigurations[configId]};
                this.removeUnneededData(campaignConfigurationsDataToPost);
                campaignConfigurations[configId] = {
                    ...campaignConfigurationsDataToPost,
                };
            }
        });
        return campaignConfigurations;
    }

    removeUnneededData(campaignConfigurationsData) {
        // Se eliminan datos que no se necesitan asi el post ocupa menos espacio
        delete campaignConfigurationsData.all_active_account_adgroups;
        delete campaignConfigurationsData.all_active_account_campaigns;
        delete campaignConfigurationsData.all_not_active_account_adgroups;
        delete campaignConfigurationsData.all_not_active_account_campaigns;
        delete campaignConfigurationsData.all_actions;
        // De solo lectura: la regla de cruce con GA4 se guarda en la agencia o en la cuenta, nunca
        // desde la línea (el backend igual la ignora en este PUT).
        delete campaignConfigurationsData.ga4_attribution;
    }

    businessUnitId() {
        return this.props.match.params.id;
    }

    // urls

    getCampaignsConfigurationDataURL(adAccountId, configId) {
        return `${API_URL}get-campaigns/${adAccountId}/${configId}`
    }

    getDeleteCampaignConfigurationURL(configId) {
        return `${API_URL}campaigns-configurations/${configId}/delete`
    }

    editCampaignsConfigurationURL() {
        return `${API_URL}business-unit/${this.businessUnitId()}/campaigns-configurations/edit`;
    }

    budgetURL() {
        return `${API_URL}business-unit/${this.businessUnitId()}/budget`;
    }

    businessUnitAccountsURL() {
        return `${API_URL}business-unit/${this.props.match.params.id}/campaigns-configurations`
    }

    businessUnitAccountGetInactiveCampaignsURL(adAccountId) {
        return `${API_URL}agency/ad-accounts/${adAccountId}/campaigns/inactive`
    }

    businessUnitAccountGetInactiveAdgroupsURL(adAccountId) {
        return `${API_URL}agency/ad-accounts/${adAccountId}/adgroups/inactive`
    }

    businessUnitAccountUpdateEntitiesURL(adAccountId) {
        return `${API_URL}agency/ad-accounts/${adAccountId}/entities/update`
    }

    allAgencyGA4AccountsURL(){
        return `${API_URL}business-unit/${this.props.match.params.id}/all_ad_accounts/analytics`;
    }
}

export default withRouterParams(withTranslation()(BusinessUnitAccounts));
